/**
 * `@/storage/sqlite` has no web implementation on purpose: the browser's drafts live in
 * IndexedDB behind the ProjectStore port (see src/storage/projectStorePort.ts). These
 * throws exist so that a shared module quietly reaching for SQLite fails loudly in a test
 * rather than silently returning empty data at runtime.
 */
const MESSAGE = 'SQLite is not available in the browser — use the ProjectStore port instead.';

function unavailable(): never {
  throw new Error(MESSAGE);
}

export const db = {
  getAllAsync: async (..._args: unknown[]): Promise<never> => unavailable(),
  getFirstAsync: async (..._args: unknown[]): Promise<never> => unavailable(),
  runAsync: async (..._args: unknown[]): Promise<never> => unavailable(),
  execAsync: async (..._args: unknown[]): Promise<never> => unavailable(),
  withTransactionAsync: async (..._args: unknown[]): Promise<never> => unavailable(),
};

export async function initDatabase(): Promise<never> {
  return unavailable();
}
